import { StatusType } from './status'

export const ES_BLUE_COLLAR = 'ES_BLUE_COLLAR'
export const ES_BLUE_COLLAR_SUCCESS = 'ES_BLUE_COLLAR_SUCCESS'
export const ES_BLUE_COLLAR_ERROR = 'ES_BLUE_COLLAR_ERROR'
export const GET_SUSCRIPCION_AUTOPOSTULACION = 'GET_SUSCRIPCION_AUTOPOSTULACION'
export const GET_SUSCRIPCION_AUTOPOSTULACION_SUCCESS = 'GET_SUSCRIPCION_AUTOPOSTULACION_SUCCESS'
export const GET_SUSCRIPCION_AUTOPOSTULACION_ERROR = 'GET_SUSCRIPCION_AUTOPOSTULACION_ERROR'
export const PUT_SUSCRIPCION_AUTOPOSTULACION = 'PUT_SUSCRIPCION_AUTOPOSTULACION'
export const PUT_SUSCRIPCION_AUTOPOSTULACION_SUCCESS = 'PUT_SUSCRIPCION_AUTOPOSTULACION_SUCCESS'
export const PUT_SUSCRIPCION_AUTOPOSTULACION_ERROR = 'PUT_SUSCRIPCION_AUTOPOSTULACION_ERROR'

export interface Autopostulacion {
  blueCollar: boolean
  suscripto: boolean
}

export interface AutopostulacionState {
  autopostulacion: Autopostulacion
  suscribirStatus: StatusType
  loading: boolean
  error: boolean
  success: boolean
}

export const initialState: AutopostulacionState = {
  autopostulacion: {
    blueCollar: false,
    suscripto: false,
  },
  suscribirStatus: {
    loading: false,
    error: false,
    success: false,
  },
  loading: false,
  error: false,
  success: false,
}

export interface EsBlueCollar {
  type: typeof ES_BLUE_COLLAR
}

export interface EsBlueCollarSuccess {
  type: typeof ES_BLUE_COLLAR_SUCCESS
  payload: { blueCollar: boolean }
}

export interface EsBlueCollarError {
  type: typeof ES_BLUE_COLLAR_ERROR
}

export interface GetSuscripcionAutopostulacion {
  type: typeof GET_SUSCRIPCION_AUTOPOSTULACION
}

export interface GetSuscripcionAutopostulacionSuccess {
  type: typeof GET_SUSCRIPCION_AUTOPOSTULACION_SUCCESS
  payload: { suscripto: boolean }
}

export interface GetSuscripcionAutopostulacionError {
  type: typeof GET_SUSCRIPCION_AUTOPOSTULACION_ERROR
}

export interface PutSuscripcionAutopostulacion {
  type: typeof PUT_SUSCRIPCION_AUTOPOSTULACION
  payload: { suscribir: boolean }
}

export interface PutSuscripcionAutopostulacionSuccess {
  type: typeof PUT_SUSCRIPCION_AUTOPOSTULACION_SUCCESS
}

export interface PutSuscripcionAutopostulacionError {
  type: typeof PUT_SUSCRIPCION_AUTOPOSTULACION_ERROR
}

export type AutopostulacionActions =
  | EsBlueCollar
  | EsBlueCollarError
  | EsBlueCollarSuccess
  | GetSuscripcionAutopostulacion
  | GetSuscripcionAutopostulacionError
  | GetSuscripcionAutopostulacionSuccess
  | PutSuscripcionAutopostulacion
  | PutSuscripcionAutopostulacionError
  | PutSuscripcionAutopostulacionSuccess
